import ApplicationSerializer from 'cpc-license-manager/serializers/application';

export default class TrackAndTraceSerializer extends ApplicationSerializer {
  attrs = {
    features: {
      embedded: 'always',
    },
  };
}
